module.exports = __webpack_public_path__ + "static/img/prezzta4.12879223.svg";